import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ImportEmployeesPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.employees.imports.pageHeader.title')} />
}

ImportEmployeesPageHeader.displayName = 'ImportEmployeesPageHeader'
export default ImportEmployeesPageHeader
